export interface Product_Interface {
    id:number,
    title:String,
    group_title:string,
    username:string,
    product_group_id:number,
    persianDate:string,
    del:boolean,
    DeletingProccess:boolean
  }
  
  export function Empty_Product_Interface():Product_Interface{
    return{
      id:0,
      title:'',
      group_title:'',
      username: '',
      product_group_id:0,
      persianDate:'',
      del:false,
      DeletingProccess:false
    }
  }
  